export const localeCookieName = "I18n_Locale";
